import ClipBox from './ClipBox.vue';
export default ClipBox;
